import React from "react";
import {
  Popper,
  Paper,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";

function PersonMentionPopup({ anchorEl, persons, searchText, onSelect }) {
  const query = (searchText || "").toLowerCase();

  const filtered = persons.filter((p) => {
    if (!query) return true;
    return (
      p.person_name.toLowerCase().includes(query) ||
      p.employee_id.toLowerCase().includes(query) ||
      p.sevarth_id.toLowerCase().includes(query)
    );
  });

  if (filtered.length === 0 || !anchorEl) return null;

  return (
    <Popper
      open
      anchorEl={anchorEl}
      placement="top-start"
      style={{ zIndex: 1300 }}
      modifiers={[{ name: "offset", options: { offset: [0, 4] } }]}
    >
      <Paper
        elevation={4}
        sx={{
          maxHeight: 240,
          overflowY: "auto",
          minWidth: 280,
          borderRadius: "12px",
          border: "1px solid rgba(24, 116, 210, 0.12)",
          boxShadow:
            "0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            backgroundColor: "rgba(24, 116, 210, 0.04)",
          }}
        >
          <Typography variant="caption" fontWeight={600} color="text.secondary">
            Select a person
          </Typography>
        </Box>
        <List dense disablePadding>
          {filtered.map((person, idx) => (
            <ListItem
              key={idx}
              button
              onClick={() => onSelect(person)}
              sx={{
                cursor: "pointer",
                borderBottom:
                  idx < filtered.length - 1
                    ? "1px solid rgba(0,0,0,0.06)"
                    : "none",
                "&:hover": {
                  backgroundColor: "rgba(24, 116, 210, 0.08)",
                },
                py: 1,
                px: 2,
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body2" fontWeight={600} color="#1a1a1a">
                    {person.person_name}
                  </Typography>
                }
                secondary={
                  <Box
                    component="span"
                    sx={{ display: "flex", gap: 2, mt: 0.25 }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      ID: {person.employee_id}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Sevarth: {person.sevarth_id}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Popper>
  );
}

export default PersonMentionPopup;
